import { render, staticRenderFns } from "./OrganizationCasePrinter.vue?vue&type=template&id=f5b7f7ec&scoped=true"
import script from "./OrganizationCasePrinter.vue?vue&type=script&lang=js"
export * from "./OrganizationCasePrinter.vue?vue&type=script&lang=js"
import style0 from "./OrganizationCasePrinter.vue?vue&type=style&index=0&id=f5b7f7ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b7f7ec",
  null
  
)

export default component.exports